<template>
  <label :for="inputId" class="form-label">
    {{ labelText }}
  </label>
  <ul class="nav nav-pills">
    <li class="nav-item" :onclick="doShowEmail">
      <a
        :class="['nav-link', showEmail ? 'active' : null]" style="cursor: pointer;"
        aria-current="page"
        >PEO (Posta Elettronica Ordinaria)</a
      >
    </li>
    <li class="nav-item" :onclick="doShowPec">
      <a :class="['nav-link', showPec ? 'active' : null]" style="cursor: pointer;"
        >PEC (Posta Elettronica Certificata)</a
      >
    </li>
  </ul>

  <textInput
    v-if="showEmail"
    :labelKey="'email'"
    :inputId="'email'"
    :pattern="patternEmail"
    :errorLabelKey="'email' + '-field-not-ok'"
    :maxlength="'350'"
    :required="showEmail"
    :ref="'email'"
    :type="'email'"
    @textInput-changed="onEmailChange"
  />

  <textInput
    v-if="showPec"
    :labelKey="'pec'"
    :inputId="'pec'"
    :pattern="patternPec"
    :errorLabelKey="'pec' + '-field-not-ok'"
    :maxlength="'350'"
    @textInput-changed="onPecChange"
    :required="showPec"
    :ref="'pec'"
    :type="'email'"
  />

  <div class="invalid-feedback">
    {{ intl[$store.state.lang][errorLabelKey] }}
  </div>

  <div v-if="showAlert" class="alert alert-warning mt-1" role="alert">
    <div
      style="margin-bottom: 10px"
      v-html="intl[$store.state.lang]['alert_not_ok']"
    ></div>
  </div>
</template>

<script>
import intl from "./intl/intl";
import TextInput from "../textInput/TextInput.vue";

export default {
  name: "pecOrPeo",
  components: {
    textInput: TextInput,
  },

  props: {
    inputId: {
      type: String,
      default: null,
    },

    required: {
      type: Boolean,
      default: false,
    },
    errorLabelKey: {
      type: String,
      default: null,
    },
    labelKey: {
      type: String,
      default: null,
    },
    patternEmail: {
      type: String,
      default: null,
    },
    patternPec: {
      type: String,
      default: null,
    },
  },
  mounted() {},
  beforeUnmount() {},
  data: function () {
    return {
      intl: intl,
      inputField: {},
      showEmail: false,
      showPec: false,
      email: "",
      pec: "",
      showAlert: false,
    };
  },
  methods: {
    onEmailChange(email, inputId) {
      this.email = email;
      this.inputField["email"] = email;
    },
    onPecChange(pec, inputId) {
      this.pec = pec;
      this.inputField["email"] = pec;
    },
    doShowEmail() {
      this.showEmail = true;
      this.showPec = false;
      this.inputField["pec_peo"] = 1;
      this.inputField["email"] = this.email;
      //this.inputField['email'] = 1
      //this.$refs
    },

    doShowPec() {
      this.showEmail = false;
      this.showPec = true;
      this.inputField["pec_peo"] = 0;
      this.inputField["email"] = this.pec;
    },

    requiredInputIsOk() {
      let isOk = false;

      if (this.required && Object.keys(this.inputField)?.length > 0) {
        if (this.showEmail) {
          isOk = this.$refs["email"].requiredInputIsOk();
        }
        if (this.showPec) {
          isOk = this.$refs["pec"].requiredInputIsOk();
        }
      }
      if (!isOk) {
        this.showAlert = true;
      } else {
        this.showAlert = false;
      }
      return isOk;
    },
  },
  watch: {},
  computed: {
    /* email: function () {
      console.log("REFSSS EMAIL ",this.$refs["email"])
      if (this.$refs["email"]) {
        return this.$refs["email"].inputField;
      }
      return '';
    },
    pec: function () {
      if (this.$refs["pec"]) {
        return this.$refs["pec"].inputField;
      }
      return '';
    }, */

    labelText: function () {
      if (this.required) {
        return this.intl[this.$store.state.lang][this.labelKey] + "*:";
      } else {
        return this.intl[this.$store.state.lang][this.labelKey] + ":";
      }
    },
  },
};
</script>
